import React, { FC } from 'react';
import { Switch } from 'react-router-dom';

import { AnonymousRoute, Route } from 'components/common/Route';
import AppLayout from 'components/layouts/AppLayout';

import SubscriptionsAndServices from './ServicesAndSubscriptions';
import SignIn from './SignIn';
import SignOut from './SignOut';

const Routes: FC = () => (
  <Switch>
    <AnonymousRoute path='/sign-out'>
      <SignOut />
    </AnonymousRoute>
    <AppLayout>
      <AnonymousRoute path='/sign-in'>
        <SignIn />
      </AnonymousRoute>
      <Route path='/'>
        <SubscriptionsAndServices />
      </Route>
    </AppLayout>
  </Switch>
);

export default Routes;
